import React from 'react';
import { useSelector } from 'react-redux';
import { selectors as authSelectors } from '../../../../store/slices/authSlice';

import LoggedInNavigation from './LoggedInNavigation';
import LoggedOutNavigation from './LoggedOutNavigation';

type AccountNavigationProps = {
  className?: string;
};

const AccountNavigation = (props: AccountNavigationProps) => {
  const isLoggedIn = useSelector(authSelectors.isLoggedIn);

  return (
    <div {...props}>
      {isLoggedIn ? <LoggedInNavigation /> : <LoggedOutNavigation />}
    </div>
  );
};

export default AccountNavigation;
